import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { dateToString, restoreDate } from '../../ParseHelper';
import { TimerType } from '../../../System/Timer/TimerTypes';

const playerDataTimerKeys = [
    TimerType.HARVEST,
    TimerType.GIFT,
    TimerType.SPIN_WHEEL,
    TimerType.INITIAL_LOGIN,
    TimerType.LAST_PURCHASE,
    TimerType.LAST_LOGIN,
    TimerType.SHOP_GIFT,
    TimerType.AD_COOLDOWN,
    TimerType.DYNAMIC_HELPER_AI,
    TimerType.STARTER_PACK_OFFER_SHOWN,
    TimerType.PAYER_REACTIVATION_OFFER_START,
    TimerType.FARM_MINI_GAME,
    // TimerType.SEND_GIFT_REQUEST_DATE,
    // TimerType.GIFT_DATE,
    // TimerType.LAST_LOGIN_WEEK,
    // TimerType.FOX_DATE,

    // Depreciated
    // TimerType.MISSION,
    // TimerType.KEY_MISSION,
] as const;
type TimerKeys = typeof playerDataTimerKeys[number];

type PlayerStateKey = 'timers';
type PlayerDataKeys = TimerKeys;
export default class Timers implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        const saveData = this.save(playerStateData);
        return playerDataTimerKeys.some(timerTypeKey => {
            return playerEndpointData[timerTypeKey] !== saveData[timerTypeKey];
        });
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        const timers = new Map<TimerKeys, Date | null>();
        for (const timerTypeKey of playerDataTimerKeys) {
            timers.set(timerTypeKey, restoreDate(playerEndpointData[timerTypeKey]));
        }
        return timers;
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        const partialPlayerData: Pick<IPlayerData, TimerKeys> = {} as Record<
            typeof playerDataTimerKeys[number],
            string
        >;
        for (const timerTypeKey of playerDataTimerKeys) {
            const date = playerStateData.timers.get(timerTypeKey);
            partialPlayerData[timerTypeKey] = dateToString(date);
        }
        return partialPlayerData;
    }
}
